import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {gameActions} from "../../actions/gameActions";
import store from "../../store";

class Clock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            time: {},
            seconds: 30
        };
        this.timer = 0;
    }

    _start() {
        if (this.timer == 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        store.dispatch(gameActions.updateTimer(seconds));
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });
        if (seconds == 0) {
            store.dispatch(gameActions.changeStatus("STOP"));
            this.timer = 0;
            clearInterval(this.timer);
        }
    }

    _init (){
        if (this.props.game.state === "PAUSE"){
            clearInterval(this.timer);
            this.timer = 0;
        }else if (this.props.game.state === "RUN"){
            this._start();
        }else {
            clearInterval(this.timer);
        }
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = divisor_for_seconds;
        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds < 10 ? "0"+seconds : seconds,
        };
        return obj;
    }

    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({time: timeLeftVar});

    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            seconds: nextProps.game.time,
            time: this.secondsToTime(nextProps.game.time)
        })
    }

    render() {
        this._init();
        return (
            <section>
                <div className="time row">{this.state.time.m + ':'+this.state.time.s}</div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        game: state.game.entity
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({gameActions: gameActions}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Clock);



// WEBPACK FOOTER //
// ./src/components/views/Clock.js